import { CDN_URLS } from '../../constants/cdn-urls';
import { DefaultIconProps } from './types';

export const HourglassIcon = ({ className, ...props }: DefaultIconProps) => (
  <img
    className={className}
    src={`${CDN_URLS.FABLEBORNE}/assets/general/icons/hourglass.svg`}
    alt="hourglass"
    {...props}
  />
);
